// extracted by mini-css-extract-plugin
module.exports = {"lang":"kv","langWrap":"kw","item":"kx","itemCurrent":"ky"};